module.exports = __webpack_public_path__ + "Lato-Light.cf44fd55d7045a2378f9.ttf";


//////////////////
// WEBPACK FOOTER
// /Users/davidkross/Project/TaiwaneseTutor/front-end/TaiwaneseTutor/src/assets/fonts/Lato/fonts/Lato-Light.ttf
// module id = ../../../../../src/assets/fonts/Lato/fonts/Lato-Light.ttf
// module chunks = styles